import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"

import TrustyCardModule from "@modules/TrustyCardModule"
import { useBreakpoints } from "@hooks/useBreakpoints"
import { removeBolds } from "@utils/helpers"

const FiveKeySection = () => {
  const { t } = useTranslation()
  const { isDesktop } = useBreakpoints()
  return (
    <TrustyCardModule>
      {`${
        isDesktop
          ? removeBolds(t("AboutMetaloop_Paragraph4"))
          : t("AboutMetaloop_Paragraph4")
      }<br/><br />
            ${
              isDesktop
                ? removeBolds(t("AboutMetaloop_Paragraph5"))
                : t("AboutMetaloop_Paragraph5")
            }`}
    </TrustyCardModule>
  )
}

export default FiveKeySection
